/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Edit_Event_Group_Original_Font_Family_LabelInputs */



/**
* | output |
* | --- |
* | "Original Font Family" |
*
* @param {Edit_Event_Group_Original_Font_Family_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const edit_event_group_original_font_family_label = /** @type {((inputs?: Edit_Event_Group_Original_Font_Family_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Edit_Event_Group_Original_Font_Family_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Famille de polices d'origine")
	if (locale === "de") return /** @type {LocalizedString} */ ("Originale Schriftfamilie")
	if (locale === "it") return /** @type {LocalizedString} */ ("Famiglia di font originale")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Оригинальное семейство шрифтов")
	if (locale === "es") return /** @type {LocalizedString} */ ("Familia de fuentes original")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("原始字体系列")
	if (locale === "ja") return /** @type {LocalizedString} */ ("オリジナルフォントファミリー")
	if (locale === "hi") return /** @type {LocalizedString} */ ("मूल फ़ॉन्ट परिवार")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Família de fontes original")
	return /** @type {LocalizedString} */ ("Original Font Family")
});